const moment = require('moment');

const fsMomentImport = (m) => {
    if(!m){
        return m
    }

    // Moment.js does not support Timestamp object (currently used by Firestore)
    if(moment.isMoment(m) && m.isValid()){
        return m
    }

    if(moment(m).isValid()){
        return moment(m)
    }

    // Raw Firestore Timestamp dueDate = {"seconds":1607452643,"nanoseconds":541000000}
    if(typeof m.seconds === 'number'){
        return moment.unix(m.seconds)
    }
    // Firestore Timestamp preprocessed
    if(typeof m.toDate === 'function'){
        return moment(m.toDate())
    }
}

function genHash(length) {
    const chars = [..."abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"];
    let result = "";

    try {
        let array = new Uint8Array(length);
        window.crypto.getRandomValues(array);
        for(let i = 0; i < length; i++) {
            result += chars[(array[i] % chars.length)]
        }
    }
    catch (e) {
        //console.info("window.crypto.getRandomValues is not available");
        result = "";
        for(let i = 0; i < length; i++){
            const randomNr = Math.floor(Math.random() * chars.length);
            result += chars[randomNr]
        }
    }

    return result
}

exports = module.exports = {
    genHash,
    fsMomentImport
}